<app-header></app-header>

<div class="rewards_page">
    <div class="rewards_container">

        <div class="container1">

            <div class="cont_leftSide">
<div class="pts">
    <span class="pointsNum">Total Points Earned</span> <span style="font-size: 20px;" class="pt">1,023pt</span>
</div>

<div class="awards">
    <!-- <div class="award"
      [ngClass]="{ pink: i === 0, darkBlue: i === 1, blue: i === 2 }"
      > -->
    <div class="award">
      <img src="../../assets/images/a1.png" alt=""></div>
</div>
            </div>

            <div class="cont_rightSide">
                <circle-progress [backgroundColor]="'#fafafd'" [backgroundStrokeWidth]="0" [backgroundPadding]="15"
                    [radius]="24" [space]="4" [toFixed]="0" [percent]="28" [maxPercent]="100" [units]="'%'" [unitsFontWeight]="'100'"
                    [unitsColor]="'#483500'" [outerStrokeWidth]="50" [outerStrokeColor]="'#15c4fc'"
                    [outerStrokeLinecap]="'inherit'" [innerStrokeColor]="'#15c4fd'" [innerStrokeWidth]="0"
                    [titleColor]="'#483500'" [titleFontSize]="'15'" [unitsFontSize]="'15'" [titleFontWeight]="'100'"
                    [subtitleColor]="'#483500'" [subtitleFontWeight]="'100'"
                    [showSubtitle]=false [responsive]=false></circle-progress>
            </div>
        </div>

        <div class="container2">
            <div class="reward_cards">
                <div class="reward_card">
                    <h4>Posture Correction</h4>
                    <div class="reward_table">
                        <div class="row1">
                            <div class="points">Points</div>
                            <div class="pr">230pt</div>
                        </div>
                        <div class="row1">
                            <div class="points">Badged</div>
                            <div class="pr">
                                <img src="../../assets/images/a1.png" alt="">
                                <img src="../../assets/images/a2.png" alt="">
                                <img src="../../assets/images/a3.png" alt="">
                                <img src="../../assets/images/a4.png" alt="">
                                <span class="numb">3 +</span>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="reward_card">
                    <h4>Posture Correction</h4>
                    <div class="reward_table">
                        <div class="row1">
                            <div class="points">Points</div>
                            <div class="pr">230pt</div>
                        </div>
                        <div class="row1">
                            <div class="points">Badged</div>
                            <div class="pr">
                                <img src="../../assets/images/a1.png" alt="">
                                <img src="../../assets/images/a2.png" alt="">
                                <img src="../../assets/images/a3.png" alt="">
                                <img src="../../assets/images/a4.png" alt="">
                                <span class="numb">3 +</span>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="reward_card">
                    <h4>Posture Correction</h4>
                    <div class="reward_table">
                        <div class="row1">
                            <div class="points">Points</div>
                            <div class="pr">230pt</div>
                        </div>
                        <div class="row1">
                            <div class="points">Badged</div>
                            <div class="pr">
                                <img src="../../assets/images/a1.png" alt="">
                                <img src="../../assets/images/a2.png" alt="">
                                <img src="../../assets/images/a3.png" alt="">
                                <img src="../../assets/images/a4.png" alt="">
                                <span class="numb">3 +</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>